export const checkEnvAvailability = (state: string) => {
  return /^(true|1|t)$/i.test(state);
};
